import { request } from '../request'

//关联子项目
export function relSubProject(data) {
  return request.post('/wenjuan/project/relSubProject', data)
}

//分页查询子项目
export function getSubProject(params) {
  return request.get('/wenjuan/project/pageSubProject', {params})
}

//取消关联子项目
export function cancelRelProject(id) {
  return request.post('/wenjuan/project/cancelRel?id=' + id)
}